<template>
  <div v-if="JobStatus > 49 && canSeeApproveButton">
    <router-btn :text="$t('servicesystem.common_objects.commonterms.approve')" :icon="approveStatsIcon"
      :color="isApproveable ? 'quaternary' : 'disabled'" :loading="loading" :disabled="initiated" :outlined="false"
      :textbtn="textbtn" :info="$t('servicesystem.common_objects.commonterms.approve')" :large="large" :small="small"
      @Press="(!initiated & isApproveable) ? action() : null">
    </router-btn>
    <ApproveJobDialog :externaltrigger="dialogtrigger" />
  </div>
</template>


<script>
import RouterBtn from "@/components/Buttons/RouterBtn.vue";
import clientAPI from "@/api/ClientAPIMixin.js";
import ApproveJobDialog from "@/components/Dialogs/ApproveJobDialog.vue";

export default {
  name: "ApproveJobBtn",
  props: ["large", "small", "textbtn"],
  components: {
    RouterBtn,
    ApproveJobDialog,
  },
  mixins: [clientAPI],

  data() {
    return {
      dialogtrigger: 0,
      initiated: false,
      loading: false,
    };
  },

  methods: {
    action2() {
      this.dialogtrigger++;
    },
    async action() {
      var config = {
        title: this.$t("servicesystem.common_objects.job.approve_job_confirm_title"),
        message: this.$t("servicesystem.common_objects.job.approve_job_confirm_body"),
        dontRemindMeKey: 'JobApprovalDontShowConfirmation',
      };
      var result = await this.$store.dispatch("ConfirmDialog/Show", config);
      if (result) {
        this.loading = true;
        this.approveJob(this.$route.params.jobId)
          .then(() => {
            this.$router.push({ query: { timestamp: this.getNowTime(this.oldTimeFormat) } });
            this.initiated = true;
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
  },

  computed: {
    approveStatsIcon() {
      return this.statusicon(70);
    },

    isApproveable() {
      return this.$store.getters["JobHub/IsApproveable"];
    },
    JobStatus() {
      return this.$store.getters["JobHub/JobStatus"];
    },
    canSeeApproveButton() {
      const isTechnician = this.userInfo.UserTypeId === 2;
      const isAdmin = this.userInfo.UserTypeId === 1;
      const technicianCanApprove = this.$store?.state?.GlobalSettings?.TechnicianCanApproveJob === true;
      // Hide button for technicians when setting is disabled
      return isAdmin || (isTechnician && technicianCanApprove);
    },
  },

  watch: {},
};
</script>

<style lang="scss" scoped></style>
